module.exports = require("p-map");


//////////////////
// WEBPACK FOOTER
// external "p-map"
// module id = 15
// module chunks = 0